import React, { Component } from 'react'

export default class Footer extends Component {
  render() {
    return (
    <footer className="footer py-3">
    <div className="container">
      <p className="small mb-0 text-light">Created With React</p>
      <p>Copyright Andrew Smyth 2023</p>
    </div>
  </footer>
  )
}
}